import "./App.css";
import CalculatorContainer from "./components/CalculatorContainer/CalculatorContainer";

function App() {
  return (
    <div className="App">
      <CalculatorContainer />
    </div>
  );
}

export default App;
